import { useState } from "react";

import { TFinalSort, TSort } from "components/Table/types";

type TUseRawSortRes = [
  sort: Record<string, TFinalSort>,
  setSort: (newSort: TSort, singleSort?: boolean) => void,
  replaceSort: (sort: Record<string, TFinalSort>) => void,
];

export const useRawSort = (
  defaultSort: Record<string, TFinalSort>
): TUseRawSortRes => {
  const [sort, _setSort] = useState<Record<string, TFinalSort>>(defaultSort);

  const setSort = (newSort: TSort, multiSort?: boolean) => {
    _setSort((prev) => {
      let prevSort = prev;

      if (!multiSort) {
        for (const key in prevSort) {
          prevSort = {
            ...prevSort,
            [key]: {
              ...prevSort[key],
              type: "none",
            },
          };
        }
      }

      return {
        ...prevSort,
        [newSort.key]: {
          fieldName: newSort.fieldName,
          type: newSort.type,
          key: newSort.key,
          order: new Date().getTime(),
        },
      };
    });
  };

  const replaceSort = (sort: Record<string, TFinalSort>) => {
    _setSort(sort);
  };

  return [sort, setSort, replaceSort];
};
